// extracted by mini-css-extract-plugin
module.exports = {"videoContainer":"Media_component_videoContainer__1rIO6"};